import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Chatting from "./pages/Chatting";
import ChatLayout from "./layouts/ChatLayout/ChatLayout";
import LoginPage from "./pages/LoginPage";
import HomePage from "./pages/HomePage";

export default function Router() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<HomePage />} />
      <Route element={<ChatLayout />}>
        <Route path="/chatting" element={<Chatting />} />
      </Route>
    </Routes>
  );
}
